<template>
  <div
    class="read-more"
    :class="{
      'read-more--is-active': isOverflowing,
      'read-more--is-open': overflowIsVisible,
    }"
  >
    <div class="read-more__inner">
      <div
        ref="wrapperElement"
        class="read-more__wrapper"
        :class="wrapperClass"
      >
        <slot />
      </div>
    </div>

    <div v-if="isOverflowing" class="read-more__overlay"></div>

    <button
      v-if="isOverflowing"
      class="read-more__button"
      @click="overflowIsVisible = !overflowIsVisible"
    >
      <a-label :path="overflowIsVisible ? 'readLess' : 'readMore'" is-visible />
    </button>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useElementSize } from '@vueuse/core';

const OVERFLOW_HEIGHT = 300;

const wrapperElement = ref(null);
const { height } = useElementSize(wrapperElement);

defineProps({
  wrapperClass: {
    type: String,
    default: '',
  },
});

const isOverflowing = computed(() => {
  return height.value > OVERFLOW_HEIGHT;
});

const overflowIsVisible = ref(false);
</script>
